<template>
  <div class="actions-row">
    <v-tooltip top v-if="permissions.catalog.services.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="toggle_(value)"
        >
          <v-icon >{{ (!value.active ? 'mdi-checkbox-marked-circle-outline' : 'mdi-cancel') }}</v-icon>
        </v-btn>
      </template>
      <span>{{ (value.active ? lang.services.status.deactivate : lang.services.status.activate) }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.catalog.services.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="$emit('edit', value)"
        >
          <v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.services.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.catalog.services.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="delete_(value)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.services.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import actions from '../../mixins/actions'

export default {
  mixins: [ appdata, actions ],
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
